//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import "../../../components/desktop/ecourse/EcourseMenuOption/EcourseMenuOption";
import "../../../components/shared/FaqCard/FaqCard";

class FaqPage extends PolymerElement {
  static get template() {
    return html `
      <style>
        .container {
          margin: 0 auto;
          padding: 26px 2px 150px;
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }
        .main-container {
          width: 660px;
        }
        .side-container {
          width: 320px;
        }

        .main-container h1 {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          color: #000000;
          margin-bottom: 12px;
        }
      </style>
      <div class="container">
        <!-- SIDE CONTAINER -->
        <div class="side-container">
          <ecourse-menu-option user-uid="{{userUid}}"></ecourse-menu-option>
        </div>
        <!-- SIDE CONTAINER -->

        <!-- MAIN CONTAINER -->
        <div class="main-container">
          <h1>FAQ</h1>
          <dom-repeat items="{{listFaqs}}" as="listFaq">
            <template>
                <faq-card list-faq="{{listFaq}}"></faq-card>
            </template
          </dom-repeat>
        </div>
        <!-- MAIN CONTAINER -->
      </div>
    `;
  }

  static get properties() {
    return {
      listFaqs: {
        type: Array,
      },
      userUid: {
        type: String,
      },
    };
  }

  ready() {
    super.ready();
  }
}

customElements.define("faq-page", FaqPage);